import { render, staticRenderFns } from "./UploadSkeleton.vue?vue&type=template&id=1fa76f8d&scoped=true&"
import script from "./UploadSkeleton.vue?vue&type=script&lang=ts&"
export * from "./UploadSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./UploadSkeleton.vue?vue&type=style&index=0&id=1fa76f8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa76f8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
